// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"8108e5ec","208":"c54a944b","279":"33c2f4f8","421":"208657ab","483":"9bb34e91","558":"2e09d75b","616":"6d32dd08","630":"1ae6db76","667":"3a637eca","787":"209adc8d"}[chunkId] + ".chunk.js";
};